// extracted by mini-css-extract-plugin
module.exports = {"section-title":"SectionTitle_section-title__2ZXPo"};